// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor)
Vue.use(Vuetify, { directives: { ripple } })

const lightTheme = {
  primary: '#009DD9',
  secondary: '#21566e',
  accent: '#41A69D',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
  realty: '#215676',
  realEstate: '#F37A76',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  theme: {
    themes: {
      light: lightTheme,
    },
  },
})
